module.exports = __webpack_public_path__ + "static/media/lifestyle.f7c8f432.png";